module.exports = __webpack_public_path__ + "static/media/institute-17-min.4113d902.webp";